import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';

import { PerfilService } from './perfil.service';


import { Observable } from 'rxjs';
import { AngularFireStorage } from '@angular/fire/storage';


@Component({
  selector: 'perfil',
  templateUrl: './perfil.component.html',
  styleUrls: ['./perfil.component.scss'],
  providers: [PerfilService]
})
export class PerfilComponent implements OnInit {
  mySplit: (string: any, nb: any) => any;
  angular: any;

  isLoading: boolean; 

  constructor(private perfilService: PerfilService, private rutaActiva: ActivatedRoute, private storage: AngularFireStorage) { }
  perfilFotoURL: Observable<any>;
  radiografiaURL: Observable<any>;
  idPolitician: string;
  politician: any;
  single: any;
  //datos de grafica de asistencia
  comisionsIndic: any;
  iniciativasIndic: any;
  transparenciaIndic: any;
  socialIndic: any;
  partidosBD: Observable<any[]>;
  data: any[];
  diputados: any[];
  senadores: any[];
  partidos: any[];

  ngAfterViewInit() {
    this.isLoading = false;
    var FBSDK = document.getElementById("facebook-jssdk");
    if (FBSDK) {
      FBSDK.remove();
    }
    (function (d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s); js.id = id;
      js.src = "//connect.facebook.net/en_US/sdk.js#xfbml=1&version=v2.9";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));
  }
  ngOnInit() {
    this.isLoading = true;
    this.idPolitician = this.rutaActiva.snapshot.params.id,
      this.rutaActiva.params.subscribe(
        (params: Params) => {
          this.idPolitician = params.id;
        }
      );
    //this.politician = this.politiciansService.getPolitico(this.idPolitician);
    this.perfilService.getPolitico(this.idPolitician).subscribe((pol) => {
      let p:any = pol.payload.data();
      p.percentile_Indicators.total = Math.round(p.percentile_Indicators.total)
      p.percentile_Indicators.assistances = Math.round(p.percentile_Indicators.assistances)
      this.politician = p;
      // console.log("ENTRO:  " + JSON.stringify(this.politician.cargos.length));
      
      //this.politician.partidoPolitico = this.politician.partidoPolitico.split("-", 1);

      this.mySplit = function (string, nb) {
        var array = string.split('-');
        return array[nb];
      }

      // this.single = [
      //   {
      //     "name": "Asistencias",
      //     "value": this.politician.percentile_Indicators['assistances']
      //   },
      //   {
      //     "name": "Inasistencias",
      //     "value": this.politician.percentile_Indicators['inasistencias']
      //   }
      // ];

      // this.comisionsIndic = [
      //   {
      //     "name": "Asistencias en comisiones",
      //     "value": this.politician.indicadores['comisiones']
      //   },
      //   {
      //     "name": "Faltas en comisiones",
      //     "value": this.politician.indicadores['total_comisiones'] - this.politician.indicadores['comisiones']
      //   }
      // ];

      // this.iniciativasIndic = [
      //   { "name": "Iniciativas", "value": this.politician.indicadores['iniciativas'] }
      // ];


      this.transparenciaIndic = [
        {
          "name": "Presentó 3 de 3",
          "value": this.politician.percentile_Indicators['transparency'] * 100
        }
      ];

      this.socialIndic = [
        { "name": "Facebook", "value": parseInt(this.politician.no_followers_facebook, 10) },
        { "name": "Instagram", "value": parseInt(this.politician.no_followers_instagram, 10) },
        { "name": "Twitter", "value": parseInt(this.politician.no_followers_twitter, 10) }
      ];


      // this.politician.rating = this.politician.percentile_Indicators['total'];

      this.perfilFotoURL = this.storage.ref(this.politician.image_path).getDownloadURL();
      //alert("AQUI " + this.politician.pathPol);
      this.radiografiaURL = this.storage.ref(this.politician.radiography_path).getDownloadURL();

    });

  }
  news = [];
  placeholders = [];
  pageSize = 10;
  pageToLoadNext = 1;
  loading = false;
  view: any[] = [900, 300];
  colorScheme = {
    domain: ['#20d073', '#f74c6e', '#C7B42C', '#AAAAAA']
  };
  viewTransp: any[] = [200, 300];
  gradient = false;
  showXAxis = true;
  showYAxis = false;
  showLegend = false;
  showXAxisLabel = true;
  xAxisLabel = '';
  showYAxisLabel = true;
  yAxisLabel = 'Population';

  onSelect(event) {
    console.log(event);
  }






}
